

export default function TechnologyCard({
    number,
    duration="Year",
    technology
}) {
    return (
        <h2 className="d-block d-lg-flex justify-content-between fw-light border border-primary text-uppercase py-1 px-3">
            <div className="d-flex">
                <div className="number">{number}</div>
                <h3 className="duration ms-3 me-5">{duration}</h3>
            </div>
            <div className="technology mt-2 mt-lg-0">{technology}</div>
        </h2>
    )
}